/** Generated by @jobilla/openapi-codegen. Do not edit manually. */

import type { AxiosRequestConfig, AxiosResponse } from 'axios'
import { axiosInstance } from '../client'
import type {
	OrganisationPrivacyUpdatePathParams,
	OrganisationPrivacyUpdateRequest,
	OrganisationPrivacyUpdateResponse,
} from '../types/OrganisationPrivacyUpdate'

/**
 * PUT /organisations/:organisation/privacy
 * @see backend/nexus/modules/Organisation/Http/Controllers/OrganisationPrivacyController.php OrganisationPrivacyController::update
 */
export async function organisationPrivacyUpdate(
	organisation: OrganisationPrivacyUpdatePathParams['organisation'],
	data: OrganisationPrivacyUpdateRequest,
	config?: AxiosRequestConfig,
): Promise<AxiosResponse<OrganisationPrivacyUpdateResponse>> {
	return axiosInstance.put(`/organisations/${organisation}/privacy`, data, config)
}
